export default "__VITE_ASSET__BHGqxa$k__"